"use strict";
/**
 *
 * makeRow
 *
 */
Object.defineProperty(exports, "__esModule", { value: true });
// parts
const RowHeader_1 = require("./RowHeader");
const RowSticky_1 = require("./RowSticky");
const RowItem_1 = require("./RowItem");
exports.makeRow = (config) => {
    return {
        RowHeader: RowHeader_1.makeRowHeader(config),
        RowSticky: RowSticky_1.makeRowSticky(config),
        RowItem: RowItem_1.makeRowItem(config),
    };
};
